import React from 'react';
import moment from 'moment';
import styled from 'styled-components';
import {useIntl} from 'react-intl';
import {durationFormat} from '../../../../helpers/date';

const Style = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0 1rem;
  text-align: left;
  line-height: 1rem;
  font-size: 0.8rem !important;
`;

const Location = ({currentPosition, theme, timezone}) => {
  const intl = useIntl();

  return (
    <Style className="mt-3">
      <strong className="mb-1" style={{color: theme}}>
        {intl.formatMessage({id: 'personalDeviceLastUpdate'})}
      </strong>
      <span className="text-gray">
        {!!currentPosition?.fixTime ? moment(currentPosition.fixTime).tz(timezone).format(
            'YYYY-MM-DD HH:mm:ss',
        ) : intl.formatMessage({id: 'notAvailable'})}
      </span>
      <span className="text-gray">
        {intl.formatMessage({id: 'deviceStoppedFor'})}: {currentPosition?.attributes?.stoppedTime != null ?
          durationFormat(currentPosition.attributes.stoppedTime, 'HH:mm:ss') :
          intl.formatMessage({id: 'notAvailable'})}
      </span>
      <strong className="mt-1 mb-1" style={{color: theme}}>
        {intl.formatMessage({id: 'sharedAddress'})}
      </strong>
      <span className="text-gray">{!!currentPosition?.address ? currentPosition?.address : intl.formatMessage({id: 'notAvailable'})}</span>
    </Style>
  );
};

export default Location;
